<template>
  <div class="invite-notice">
    <span class="typo-body-s-bold">프로모션 유의사항</span>

    <div class="invite-notice__group">
      <span class="typo-body-s-bold" style="color: var(--color-text-sub, #6B7684);">참여 대상</span>
      <ul class="invite-notice__list">
        <li class="typo-caption-xs-medium">초대한 친구: 솔닥 컨시어지 회원 누구나</li>
        <li class="typo-caption-xs-medium">초대받은 친구: 솔닥 컨시어지에서 연속혈당측정기 구매 이력이 없는 고객</li>
      </ul>
    </div>

    <div class="invite-notice__divider"></div>

    <div class="invite-notice__group">
      <span class="typo-body-s-bold" style="color: var(--color-text-sub, #6B7684);">참여 방법</span>
      <ol class="invite-notice__list invite-notice__list--ordered">
        <li class="typo-caption-xs-medium">초대 코드 공유: 추천인이 친구에게 초대 코드 또는 링크 전달</li>
        <li class="typo-caption-xs-medium">초대 코드 등록: 친구는 회원가입 후 추천인 코드를 등록</li>
        <li class="typo-caption-xs-medium">첫 주문: 초대 받은 친구가 솔닥 컨시어지에서 연속혈당측정기를 첫 구매하면 완료!</li>
      </ol>
      <ul class="invite-notice__list">
        <li class="typo-caption-xs-medium">결제 전에 초대 코드가 등록되어야 혜택이 적용됩니다.</li>
        <li class="typo-caption-xs-medium">추천인 등록 후 100일 안에 결제를 완료해야 혜택이 적용됩니다.</li>
      </ul>
    </div>

    <div class="invite-notice__divider"></div>

    <div class="invite-notice__group">
      <span class="typo-body-s-bold" style="color: var(--color-text-sub, #6B7684);">유의 사항</span>
      <ul class="invite-notice__list">
        <li class="typo-caption-xs-medium">혜택은 계정에 등록된 환자정보의 전화번호로 발송됩니다.<br>(환자 프로필이 여러개일 경우 가장 먼저 등록한 프로필 번호 기준)</li>
        <li class="typo-caption-xs-medium">반드시 지정된 경로(초대 링크 이용 또는 코드 직접 입력)를 통해 참여해 주세요.</li>
        <li class="typo-caption-xs-medium">추천인 등록 시점 기준, 연속혈당측정기 구매 이력이 있는 계정은 이벤트 대상에서 제외됩니다.</li>
        <li class="typo-caption-xs-medium">부적절한 방법(계정 도용, 동일인 중복 가입 등)으로 참여 시 혜택 지급이 제외되거나 회수될 수 있습니다.</li>
        <li class="typo-caption-xs-medium">본 프로모션은 당사 사정에 따라 별도의 고지 없이 변경되거나 조기 종료될 수 있습니다.</li>
        <!-- <li class="typo-caption-xs-medium">연속혈당측정기 제품 중 ‘가디언4(미니메드 780G) 및 ‘가디언4 (Standalone)’ 제품은 이벤트 대상에서 제외됩니다.</li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteNoticeSection',
}
</script>

<style scoped>
.invite-notice {
  display: flex;
  width: 100%;
  padding: 16px 16px 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background: var(--color-bg-gray, #F2F4F6);
  box-sizing: border-box;
}

.invite-notice__group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}

.invite-notice__list {
  margin: 0;
  padding-left: 20px;
}

.invite-notice__list li {
  color: var(--color-text-sub, #6B7684);
}

.invite-notice__list--ordered {
  list-style-type: decimal;
}

.invite-notice__divider {
  height: 1px;
  align-self: stretch;
  background: var(--color-divider-200, #E5E8EB);
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteNoticeSection.vue